import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  api: 'backend/',
  changePassword: true,
  fullname: '',
  lang: 'fr',
  title: '',
  token: null,
  adminLevel: 0,
  licence: 0
}

// SET THE CURRENT LANGUAGE
if (typeof localStorage.getItem('lang') !== 'undefined') {
  var temp = localStorage.getItem('lang')
  if (temp === null) {
    localStorage.setItem('lang', state.lang)
  } else {
    state.lang = temp
  }
} else {
  localStorage.setItem('lang', state.lang)
}

const getters = {
  isAuthenticated: state => {
    return state.token != null
  },
  needPasswordChange: state => {
    return state.changePassword === true
  },
  adminLevel: state => {
    return state.adminLevel
  },
  licence: state => {
    return state.licence
  }
}

const mutations = {
  AUTHENTICATE (state, obj) {
    if (typeof obj.changePassword !== 'undefined') {
      state.changePassword = obj.changePassword
      sessionStorage.setItem('changePassword', obj.changePassword)
    }
    if (typeof obj.fullname !== 'undefined') {
      state.fullname = obj.fullname
      sessionStorage.setItem('fullname', obj.fullname)
    }
    if (typeof obj.token !== 'undefined') {
      state.token = obj.token
      sessionStorage.setItem('token', obj.token)
    }
    if (typeof obj.adminLevel !== 'undefined') {
      state.adminLevel = obj.adminLevel
      sessionStorage.setItem('adminLevel', obj.adminLevel)
    }
    if (typeof obj.licence !== 'undefined') {
      state.licence = obj.licence
      sessionStorage.setItem('licence', obj.licence)
    }
  },
  LOGOUT (state) {
    state.changePassword = true
    state.fullname = ''
    state.token = null
    sessionStorage.removeItem('fullname')
    sessionStorage.removeItem('token')
    state.adminLevel = 0
    state.licence = 0
  },
  LANGUAGE (state, lang) {
    if (typeof lang !== 'undefined') {
      state.lang = lang
      localStorage.setItem('lang', lang)
    }
    console.log('DEBUG' + state.lang)
  },
  UPDATE_TITLE (state, title) {
    state.title = title
  }
}

const actions = {
}

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/vuex/store.js